"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalData = exports.StorageKeys = void 0;
const logger_1 = require("../class/logger");
var StorageKeys;
(function (StorageKeys) {
    StorageKeys[StorageKeys["sessionId"] = 0] = "sessionId";
    StorageKeys[StorageKeys["localId"] = 1] = "localId";
    StorageKeys[StorageKeys["fingerprint"] = 2] = "fingerprint";
    StorageKeys[StorageKeys["userId"] = 3] = "userId";
})(StorageKeys = exports.StorageKeys || (exports.StorageKeys = {}));
const isBrowser = typeof window !== 'undefined';
class LocalData {
    static get hasStorage() {
        return isBrowser && !!(window === null || window === void 0 ? void 0 : window.localStorage);
    }
    static get hasSession() {
        return isBrowser && !!(window === null || window === void 0 ? void 0 : window.sessionStorage);
    }
    static readStorage(key) {
        var _a;
        if (!isBrowser) {
            return (_a = this.inMemoryLocal[key]) !== null && _a !== void 0 ? _a : null;
        }
        return LocalData.read(window === null || window === void 0 ? void 0 : window.localStorage, key);
    }
    static writeStorage(key, data) {
        if (!isBrowser) {
            this.inMemoryLocal[key] = data;
            return;
        }
        if (data === null) {
            this.delete(window === null || window === void 0 ? void 0 : window.localStorage, key);
            return;
        }
        this.write(window === null || window === void 0 ? void 0 : window.localStorage, key, data);
        return;
    }
    static deleteStorage(key) {
        if (!isBrowser && this.inMemoryLocal[key]) {
            delete this.inMemoryLocal[key];
            return;
        }
        this.delete(window === null || window === void 0 ? void 0 : window.localStorage, key);
    }
    static readSession(key) {
        var _a;
        if (!isBrowser) {
            return (_a = this.inMemorySession[key]) !== null && _a !== void 0 ? _a : null;
        }
        return LocalData.read(window === null || window === void 0 ? void 0 : window.sessionStorage, key);
    }
    static writeSession(key, data) {
        if (!isBrowser) {
            this.inMemorySession[key] = data;
            return;
        }
        if (data === null) {
            this.delete(window === null || window === void 0 ? void 0 : window.sessionStorage, key);
            return;
        }
        this.write(window === null || window === void 0 ? void 0 : window.sessionStorage, key, data);
    }
    static deleteSession(key) {
        if (!isBrowser && this.inMemorySession[key]) {
            delete this.inMemorySession[key];
            return;
        }
        this.delete(window === null || window === void 0 ? void 0 : window.sessionStorage, key);
    }
    static read(ctx, key) {
        if (!ctx) {
            return null;
        }
        try {
            const data = ctx.getItem(this.fullKey(key));
            return data ? JSON.parse(data) : null;
        }
        catch (err) {
            logger_1.Logger.handle(err);
            return null;
        }
    }
    static write(ctx, key, data) {
        if (!ctx) {
            return;
        }
        try {
            ctx.setItem(this.fullKey(key), JSON.stringify(data));
        }
        catch (err) {
            logger_1.Logger.handle(err);
        }
    }
    static delete(ctx, key) {
        if (!ctx) {
            return;
        }
        try {
            ctx.removeItem(this.fullKey(key));
        }
        catch (err) { }
    }
    static fullKey(key) {
        return `_gal${key}`;
    }
}
exports.LocalData = LocalData;
Object.defineProperty(LocalData, "inMemoryLocal", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {}
});
Object.defineProperty(LocalData, "inMemorySession", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {}
});
